import { CHECK_CERTIFICATE_RESET_RECEIVE } from '../actions/actions';
const initialState = {};

export default function checkCertificateReset(state=initialState, action) {
  // console.log(action.type, action);
  switch (action.type) {
    case CHECK_CERTIFICATE_RESET_RECEIVE:
      console.log("return action.payload", action.payload);
      return Object.assign({},
        state,
        action.payload
      );
    default:
      return state;
  }
}